export const FETCH_USER = 'FETCH_USER';
export const USER_GAME_CONFIGS = 'USER_GAME_CONFIGS';
export const UPDATE_USER_GAME_CONFIGS = 'UPDATE_USER_GAME_CONFIGS';
export const FETCH_CALENDAR_CONFIG = 'FETCH_CALENDAR_CONFIG';
export const FETCH_CALENDAR_CATEGORIES = 'FETCH_CALENDAR_CATEGORIES';
export const FETCH_LABELS_CONFIG = 'FETCH_LABELS_CONFIG';
export const FETCH_MEPHISTO = 'FETCH_MEPHISTO';
export const LOG_OUT = 'LOG_OUT';
